import React, { Component } from 'react';

import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import Icon from '@ant-design/icons';

import cn from '../../../utils/cn';
import { Title, Tabs, PanelLayout } from '../../../components';

import ObjectData from './object-data';
import ObjectReview from './object-review';
import ObjectPrice from './object-price';
import CircleInfoIcon from '../../../../public/images/catalog/circle-info.svg';
import PriceIcon from '../../../../public/images/catalog/price.svg';
import ReviewsIcon from '../../../../public/images/catalog/reviews.svg';

const { TabPane } = Tabs;
const { PanelHeader, PanelContent } = PanelLayout;

@withRouter
@withTranslation('harmful objects')
@cn('pesticide')
export default class ObjectDetail extends Component {
    state = {
        tab: '1'
    };

    onTabChange = (key) => {
        this.setState({ tab: key });
    };

    render() {
        const { cn } = this;
        const { t } = this.props;
        const { tab } = this.state;

        return (
            <PanelLayout>
                <PanelHeader>
                    <Title title={t('title harmful')} />
                </PanelHeader>
                <PanelContent>
                    <Tabs
                        className={cn()}
                        onChange={this.onTabChange}
                        activeKey={tab}>
                        <TabPane
                            tab={(
                                <span>
                                    <Icon component={CircleInfoIcon} />
                                    {t('about')}
                                </span>
                            )}
                            key="1">
                            <ObjectData onTabChange={this.onTabChange} />
                        </TabPane>
                        {/* <TabPane
                            tab={(
                                <span>
                                    <Icon component={PriceIcon} />
                                    {t('price')}
                                </span>
                            )}
                            key="2">
                            <ObjectPrice />
                        </TabPane> */}
                        { /* <TabPane
                            disabled
                            tab={(
                                <span>
                                    <Icon component={ReviewsIcon} />
                                    {t('review')}
                                </span>
                            )}
                            key="3">
                            <ObjectReview />
                        </TabPane> */ }
                    </Tabs>
                </PanelContent>
            </PanelLayout>
        );
    }
}